// Okt 2026 — Mode peran aktif.
// Akun yang punya role tambahan (assigned_roles) bisa bekerja "sebagai" role itu,
// misalnya Finance yang merangkap Marketing. Selama di mode itu, semua request ke
// server membawa header X-Active-Role dan useAuth() melihat role tersebut.
// Server tetap memvalidasi header terhadap assigned_roles, jadi ini bukan celah izin.
import { createContext } from "react";
import axios from "axios";

let activeRole = null;

export const getActiveRole = () => activeRole;
export const setActiveRole = (role) => {
  activeRole = role || null;
};

// Konteks yang dibaca useAuth(): berisi nama role aktif, atau null.
export const ActiveRoleContext = createContext(null);

// Role tambahan yang boleh dipakai sebagai mode. Harus sama dengan SWITCHABLE_ROLES di backend.
export const SWITCHABLE_ROLES = ["marketing"];

export const hasAssignedRole = (user, role) =>
  !!user &&
  (user.assigned_roles || []).map((r) => String(r).toLowerCase()).includes(role) &&
  String(user.role || "").toLowerCase() !== role;

let installed = false;
export function installActiveRoleHeader() {
  if (installed) return;
  installed = true;
  const backend = process.env.REACT_APP_BACKEND_URL || "";

  axios.interceptors.request.use((config) => {
    if (activeRole) {
      config.headers = config.headers || {};
      try {
        if (typeof config.headers.set === "function") config.headers.set("X-Active-Role", activeRole);
        else config.headers["X-Active-Role"] = activeRole;
      } catch (_) { /* abaikan */ }
    }
    return config;
  });

  if (typeof window !== "undefined" && typeof window.fetch === "function") {
    const original = window.fetch.bind(window);
    window.fetch = (input, init) => {
      try {
        if (activeRole && typeof input === "string" && (input.startsWith(`${backend}/api`) || input.startsWith("/api"))) {
          const headers = new Headers((init && init.headers) || {});
          headers.set("X-Active-Role", activeRole);
          return original(input, { ...(init || {}), headers });
        }
      } catch (_) { /* jatuh ke fetch biasa */ }
      return original(input, init);
    };
  }
}
